<ion-header class="ion-no-border page">

  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button (click)="goBack()" defaultHref="/dashboard"></ion-back-button>
    </ion-buttons>
    <ion-title mode="ios">
      <div  (click)="goHome()" class="header-logo">&nbsp;</div>
    </ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="showMenu()" class="menu" [attr.aria-label]="'ARIA.MENU.BUTTON.LABEL_0' | translate">
        <ion-icon slot="icon-only" aria-hidden="true"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>

  <div class="page-title" translate>{{title}} {{getDateShort(questionDate)}}</div>

</ion-header>

<ion-content class="ion-padding page2" no-bounce>
  <div class="v-box justify-around full-height">
    <rich-text [text]="description"></rich-text>
  </div>
</ion-content>

<ion-footer class="page2">
  <ion-grid>
    <ion-row>
      <ion-col size="12">
        <ion-button fill="solid" shape="round" expand="block" color="light" class="yes-button" (click)="onNextClick()">
          <div translate>COMMON.NEXT</div>
        </ion-button>
      </ion-col>
    </ion-row>
    <ion-row *ngIf="skipButtonsVisible" class="not-first-button-line">
      <ion-col size="6">
        <ion-button fill="solid" shape="round" expand="block" color="light" class="half-width" (click)="onSkipClick()">
          <div translate>COMMON.SKIP</div>
        </ion-button>
      </ion-col>
      <ion-col size="6">
        <ion-button fill="solid" shape="round" expand="block" color="light" class="half-width" [disabled]="!canSkipAll" (click)="onSkipAllClick()">
          <div translate>COMMON.SKIP_ALL</div>
        </ion-button>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-footer>
